import { Box, Typography } from '@mui/material';

export const DpPlpTitle: React.FC<
	React.PropsWithChildren<{
		inner?: boolean;
	}>
> = ({ children, inner }) => (
	<Typography
		component="h1"
		sx={{
			fontSize: { xs: '19px', sm: '18px' },
			fontWeight: '800',
			marginY: !inner ? { xs: '11px', sm: '15px' } : undefined,
			textTransform: 'uppercase',
		}}
	>
		{children}
	</Typography>
);

export const DpPlpDescription: React.FC<React.PropsWithChildren> = ({ children }) => (
	<Typography
		component="p"
		sx={{
			fontSize: { xs: '14px', sm: '16px' },
			fontWeight: '400',
		}}
	>
		{children}
	</Typography>
);

export const DpPlpTitleFrame: React.FC<React.PropsWithChildren> = ({ children }) => (
	<Box
		sx={{
			marginY: { xs: '11px', sm: '15px' },
			display: 'flex',
			flexDirection: 'column',
			gap: '3px',
		}}
	>
		{children}
	</Box>
);
